import React, {Component, useState} from 'react'
import styled from 'styled-components'

interface IProps{
    value?: string
    onlyView: boolean
    onChange: (value: any) => void
    className: string
}

function InlineEditor ({value, onlyView ,onChange, className}:IProps) {

    const [editing, setEditing] = useState<boolean>(value? false : true)
    const [localValue, setLocalValue] = useState<string | null>(null)
    
    const  keyDown = (ev) => {
        if (ev.keyCode === 13) { // ENTER4
            setEditing(false)
            onChange(ev.target.value)
        }
        if (ev.keyCode === 27) { // ESC
            this.setState({editing: false})
        }
    }

    const change = (ev) => {
        setLocalValue(ev.target.value)
        onChange(ev.target.value)
    }

    const edit = (ev) => {
        setEditing(true)
        setLocalValue(value)
    }
        
    return <div className={className}>
        {editing && !onlyView
            ? <input value={localValue || ''} onKeyDown={(event)=>{
                keyDown(event)   
                }} onChange={(event)=>{
                    change(event)
                }}/>
            : <span onClick={(event)=>{
                    edit(event)
                    }}>
                {value.length > 22 ? value.substring(0, 22)+ '...' : value}
            </span>
        }
    </div>
}

export default styled(InlineEditor)`
    display: inline-block;
    margin-right: 10px;
    input {
      font-size: 12px;
      border: 0;
      border-bottom: 1px solid var(--gray-400);
      background: transparent;
      &:focus {
          outline: none;
      }
    }
`
